import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {
    Flex,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalOverlay,
    useStyleConfig,
    Image
} from '@chakra-ui/react'

export const Certificates = ({certificates}) => {
    const [overlayData, setOverlayData] = useState(null)

    const styles = useStyleConfig('Specifications')
    return (
        <>
            {certificates.length > 0 && (
                <Flex {...styles.certificates}>
                    {certificates?.map((certificate) => (
                        <Image
                            onClick={() =>
                                setOverlayData({
                                    id: certificate?.id,
                                    name: certificate?.name,
                                    image: certificate?.image
                                })
                            }
                            key={certificate?.id}
                            alt={certificate?.name}
                            src={certificate?.image}
                            {...styles.certificateImage}
                        />
                    ))}
                    <Modal
                        isCentered
                        isOpen={overlayData !== null}
                        onClose={() => setOverlayData(null)}
                    >
                        <ModalOverlay />
                        <ModalContent
                            minW={{base: '100%', lg: '6.25rem'}}
                            minH={{base: '28.25rem', lg: '29.188rem'}}
                            padding={{
                                base: '1rem 1rem 2.5rem 1rem',
                                lg: '1.5rem 1.5rem 3rem 1.5rem'
                            }}
                            backgroundColor="stokkeGray.bright"
                        >
                            <ModalCloseButton />
                            <ModalBody
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                height="100%"
                            >
                                <Image
                                    key={overlayData?.id}
                                    alt={overlayData?.name}
                                    src={overlayData?.image}
                                ></Image>
                            </ModalBody>
                        </ModalContent>
                    </Modal>
                </Flex>
            )}
        </>
    )
}

Certificates.propTypes = {
    certificates: PropTypes.array,
    maxItems: PropTypes.number
}

export default Certificates
